import ApprovalModificationApplicationPage from './ApprovalModificationApplicationPage'

export default ApprovalModificationApplicationPage